import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-transstatusbar',
  templateUrl: './transstatusbar.component.html',
  styleUrls: ['./transstatusbar.component.css']
})
export class TransstatusbarComponent implements OnInit {

  @Input() transBO: any = {};
  
  constructor() { }

  ngOnInit() {
  }

}
